export default {
  debug: {
    mock: true,
    http: false,
  },
  baseUrl: 'http://localhost/',
};
